import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import FullCreateStyleModal from "pages/de/project/create-project/components/FullCreateStyleModal";
import ImportStyleModal2 from "pages/de/project/create-project/components/ImportStyleModal2";

import CategoryContext from "context/category-context";

const EmptyStyleRecord = ({
  content = null,
  refresh = () => {},
  size = "md",
  collection = null,
  allowImport = false,
  allowCreate = true,
  handleAfterOk,
}) => {
  const [importStyleVisible, setImportStyleVisible] = useState(false);
  const [createStyleVisible, setCreateStyleVisible] = useState(false);

  const {
    tree,
    actions: { findNodeByID, findParents },
  } = useContext(CategoryContext);
  const importStyleRef = useRef();

  const navigate = useNavigate();

  const handleAfterOkDefault = (newStyle) => {
    console.log(newStyle);
    let id = newStyle?.data?.product?.id;
    if (id) {
      navigate(`/workspace/styles-master?id=${id}`);
    }
  };

  return (
    <SuiBox sx={{ my: 2, mx: 1 }}>
      <SuiBox
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderColor: ({ borders }) => borders.borderColor,

          height: 120,
          width: "100%",
          borderRadius: 4,
        }}
      >
        {content ? (
          content
        ) : (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            sx={{ height: "100%", width: "100%" }}
          >
            {allowCreate ? (
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={0.5}
                onClick={() => setCreateStyleVisible(true)}
                sx={{ cursor: "pointer" }}
              >
                <AddIcon fontSize="small" />
                <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
                  Create Style
                </SuiTypography>{" "}
              </SuiBox>
            ) : null}
            {allowImport ? (
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={0.5}
                onClick={() => setImportStyleVisible(true)}
                sx={{ cursor: "pointer" }}
              >
                <SystemUpdateAltIcon fontSize="small" />
                <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
                  Import Style
                </SuiTypography>
              </SuiBox>
            ) : null}
          </SuiBox>
        )}
      </SuiBox>
      {createStyleVisible ? (
        <FullCreateStyleModal
          handleClose={() => setCreateStyleVisible(false)}
          visible={createStyleVisible}
          isEdit={false}
          handleRefresh={refresh}
          handleAfterOk={handleAfterOk ? handleAfterOk : handleAfterOkDefault}
          collectionId={collection?.id}
        />
      ) : null}
      {importStyleVisible ? (
        <ImportStyleModal2
          handleClose={() => setImportStyleVisible(false)}
          visible={importStyleVisible}
          isEdit={false}
          categoryTree={tree}
          ref={importStyleRef}
          collection={collection}
          handleRefresh={refresh}
        />
      ) : null}
    </SuiBox>
  );
};

export default EmptyStyleRecord;
